export enum Role {
  ADMIN = "admin",
  APPRENTICE = "apprentice",
  COACH = "coach",
  APPRENTICE_SUPERVISOR = "apprentice_supervisor",
  PARENT = "parent",
}

export const roleTranslations: Record<Role, string> = {
  [Role.ADMIN]: "Admin",
  [Role.APPRENTICE]: "Lernende/r",
  [Role.APPRENTICE_SUPERVISOR]: "Berufsbildner/in",
  [Role.PARENT]: "Eltern",
  [Role.COACH]: "Coach",
};
